module.exports = __webpack_public_path__ + "img/facebook_blue.676bfd32.svg";